import { App, View } from "@pimo/pimo-app-builder";
import { DragAndDropLayout, PMDescriptionCard } from "@pimo/pimo-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";

import { TestAppState } from "../../../app";

/** Adds the project description card (#2222). */
export function addDescriptionCard(
  view: View<TestAppState, DragAndDropLayout>,
  app: App<TestAppState>
) {
  const language = app.getAppState().language || "en";

  const descriptionComponent = view.addComponent({
    component: PMDescriptionCard,
    layoutProps: {
      componentId: "descriptionComponent",
      labels: ["description"],
      description:
        getLocalizedMessage(language, "showsDescription") ||
        "Shows the description of the Project.",
      title: getLocalizedMessage(language, "description") || "Description",
    },
  });
  descriptionComponent.mapState(({ currentReport, language }) => {
    return {
      title: getLocalizedMessage(language, "description") || "Description",

      text: currentReport?.project?.description ?? "",
    };
  });
  descriptionComponent.mapVisibility(
    ({ settings }) =>
      settings?.configuration?.fieldsDefinition
        ?.filter((field) => field.purpose === "projectBasic")
        .find((field) => field.fieldName === "description")?.enabled === true
  );
}
